export function sanitizeQrJson(raw: string): string {
  // Ищем числа сразу после ":", допускаем пробелы.
  // Примеры, которые поймает:
  // "p":0930     -> prefix '"p":', zeros '0', rest '930'
  // "w":049.76   -> prefix '"w":', zeros '0', rest '49.76'
  // "q":00055    -> prefix '"q":', zeros '000', rest '55'
  return raw.replace(
    /(:\s*)(-?)(0+)(\d+(\.\d+)?)/g,
    (_fullMatch, prefix: string, sign: string, _zeros: string, rest: string) => {
      // rest уже без ведущих нулей (мы их забрали в (0+)),
      // остаётся просто собрать обратно число без этих нулей.
      return `${prefix}${sign}${rest}`;
    }
  );
}